// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M14 6H10V2M14.5 1.5L10 6M2 10H6V14M1.5 14.5L6 10'];
